"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const clsx_1 = __importDefault(require("clsx"));
const pluralize_1 = __importDefault(require("pluralize"));
const SearchResultPartyDetailsCard = ({ partyDetails, onTitleClick }) => (react_1.default.createElement("div", { className: "search-by-item" },
    react_1.default.createElement("div", { className: "search-by-item-head" },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('info-container', !!partyDetails.worksCount && 'clickable'), onClick: () => !!partyDetails.worksCount && onTitleClick(partyDetails) },
            react_1.default.createElement("div", { className: "name-block" },
                react_1.default.createElement("span", { className: "name bold" },
                    partyDetails.name,
                    ":\u00A0"),
                react_1.default.createElement("span", { className: "count bold blue-text" }, (0, pluralize_1.default)('title', partyDetails.worksCount, true))),
            partyDetails.hfaPublisherNumber && (react_1.default.createElement("div", { className: "mlc-pub-number-block" },
                react_1.default.createElement("span", { className: "small-2" }, "MLC Publisher Number:\u00A0"),
                react_1.default.createElement("span", { className: "small-2 bold" }, partyDetails.hfaPublisherNumber))),
            react_1.default.createElement("div", { className: "number-block ipi-block" }, partyDetails.ipiNumber && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", { className: "name" }, "IPI:\u00A0"),
                react_1.default.createElement("span", { className: "name bold" }, partyDetails.ipiNumber))))))));
exports.default = SearchResultPartyDetailsCard;
